/**
 * @todo This should be exported from @ftdr/blueprint_core
 * and auto generated based on class names used in component_css
 */
export const CSS_CLASSES = {
  BREADCRUMBS_ROOT: "breadcrumbs",
  BREADCRUMBS_LIST: "breadcrumbs-list",
  BREADCRUMBS_LIST_ITEM: "breadcrumbs-list-item",
  BREADCRUMBS_LAST_ITEM: "breadcrumbs-last-item",
  BREADCRUMBS_ITEM_SEPARATOR: "breadcrumbs-item-separator",
  BREADCRUMBS_BACK_BUTTON: "breadcrumbs-back-button",
};
